import { useTableContextSelectors } from 'components/Table/model/TableModel';
import { selectStickyColumnsWidth } from 'components/Table/model/selectors/selectStickyColumnsWidth';
import type { FC, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export const TableStickyContainer: FC<Props> = (props) => {
  const ctxProps = useTableContextSelectors({
    stickyColumnsWidth: selectStickyColumnsWidth,
  });

  return (
    <div
      className='ipf-table__sticky-container'
      style={{
        width: ctxProps.stickyColumnsWidth,
      }}
    >
      {props.children}
    </div>
  );
};
